export default {
	//Cached at: 0.018
	data: [
		{ x: 0, y: 0 },
		{ x: 0, y: 0.01667 },
		{ x: 0.01674, y: 0.01667 },
		{ x: 0.03347, y: 0.01667 },
		{ x: 0.05021, y: 0.01667 },
		{ x: 0, y: 0.03333 },
		{ x: 0.01674, y: 0.03333 },
		{ x: 0.03347, y: 0.03333 },
		{ x: 0.05021, y: 0.03333 },
		{ x: 0.06695, y: 0.03333 },
		{ x: 0.08368, y: 0.03333 },
		{ x: 0.10042, y: 0.03333 },
		{ x: 0, y: 0.05 },
		{ x: 0.01674, y: 0.05 },
		{ x: 0.03347, y: 0.05 },
		{ x: 0.05021, y: 0.05 },
		{ x: 0.06695, y: 0.05 },
		{ x: 0.08368, y: 0.05 },
		{ x: 0.10042, y: 0.05 },
		{ x: 0.11715, y: 0.05 },
		{ x: 0.13389, y: 0.05 },
		{ x: 0, y: 0.06667 },
		{ x: 0.01674, y: 0.06667 },
		{ x: 0.03347, y: 0.06667 },
		{ x: 0.05021, y: 0.06667 },
		{ x: 0.06695, y: 0.06667 },
		{ x: 0.08368, y: 0.06667 },
		{ x: 0.10042, y: 0.06667 },
		{ x: 0.11715, y: 0.06667 },
		{ x: 0.13389, y: 0.06667 },
		{ x: 0.15063, y: 0.06667 },
		{ x: 0.16736, y: 0.06667 },
		{ x: 0.1841, y: 0.06667 },
		{ x: 0, y: 0.08333 },
		{ x: 0.01674, y: 0.08333 },
		{ x: 0.03347, y: 0.08333 },
		{ x: 0.05021, y: 0.08333 },
		{ x: 0.06695, y: 0.08333 },
		{ x: 0.08368, y: 0.08333 },
		{ x: 0.10042, y: 0.08333 },
		{ x: 0.11715, y: 0.08333 },
		{ x: 0.13389, y: 0.08333 },
		{ x: 0.15063, y: 0.08333 },
		{ x: 0.16736, y: 0.08333 },
		{ x: 0.1841, y: 0.08333 },
		{ x: 0.20084, y: 0.08333 },
		{ x: 0.21757, y: 0.08333 },
		{ x: 0, y: 0.1 },
		{ x: 0.01674, y: 0.1 },
		{ x: 0.03347, y: 0.1 },
		{ x: 0.05021, y: 0.1 },
		{ x: 0.06695, y: 0.1 },
		{ x: 0.08368, y: 0.1 },
		{ x: 0.10042, y: 0.1 },
		{ x: 0.11715, y: 0.1 },
		{ x: 0.13389, y: 0.1 },
		{ x: 0.15063, y: 0.1 },
		{ x: 0.16736, y: 0.1 },
		{ x: 0.1841, y: 0.1 },
		{ x: 0.20084, y: 0.1 },
		{ x: 0.21757, y: 0.1 },
		{ x: 0.23431, y: 0.1 },
		{ x: 0.25105, y: 0.1 },
		{ x: 0, y: 0.11667 },
		{ x: 0.01674, y: 0.11667 },
		{ x: 0.03347, y: 0.11667 },
		{ x: 0.05021, y: 0.11667 },
		{ x: 0.06695, y: 0.11667 },
		{ x: 0.08368, y: 0.11667 },
		{ x: 0.10042, y: 0.11667 },
		{ x: 0.11715, y: 0.11667 },
		{ x: 0.13389, y: 0.11667 },
		{ x: 0.15063, y: 0.11667 },
		{ x: 0.16736, y: 0.11667 },
		{ x: 0.1841, y: 0.11667 },
		{ x: 0.20084, y: 0.11667 },
		{ x: 0.21757, y: 0.11667 },
		{ x: 0.23431, y: 0.11667 },
		{ x: 0.25105, y: 0.11667 },
		{ x: 0, y: 0.13333 },
		{ x: 0.01674, y: 0.13333 },
		{ x: 0.03347, y: 0.13333 },
		{ x: 0.05021, y: 0.13333 },
		{ x: 0.06695, y: 0.13333 },
		{ x: 0.08368, y: 0.13333 },
		{ x: 0.10042, y: 0.13333 },
		{ x: 0.11715, y: 0.13333 },
		{ x: 0.13389, y: 0.13333 },
		{ x: 0.15063, y: 0.13333 },
		{ x: 0.16736, y: 0.13333 },
		{ x: 0.1841, y: 0.13333 },
		{ x: 0.20084, y: 0.13333 },
		{ x: 0.21757, y: 0.13333 },
		{ x: 0.23431, y: 0.13333 },
		{ x: 0.25105, y: 0.13333 },
		{ x: 0, y: 0.15 },
		{ x: 0.01674, y: 0.15 },
		{ x: 0.03347, y: 0.15 },
		{ x: 0.05021, y: 0.15 },
		{ x: 0.06695, y: 0.15 },
		{ x: 0.08368, y: 0.15 },
		{ x: 0.10042, y: 0.15 },
		{ x: 0.11715, y: 0.15 },
		{ x: 0.13389, y: 0.15 },
		{ x: 0.15063, y: 0.15 },
		{ x: 0.16736, y: 0.15 },
		{ x: 0.1841, y: 0.15 },
		{ x: 0.20084, y: 0.15 },
		{ x: 0.21757, y: 0.15 },
		{ x: 0.23431, y: 0.15 },
		{ x: 0.25105, y: 0.15 },
		{ x: 0, y: 0.16667 },
		{ x: 0.01674, y: 0.16667 },
		{ x: 0.03347, y: 0.16667 },
		{ x: 0.05021, y: 0.16667 },
		{ x: 0.06695, y: 0.16667 },
		{ x: 0.08368, y: 0.16667 },
		{ x: 0.10042, y: 0.16667 },
		{ x: 0.11715, y: 0.16667 },
		{ x: 0.13389, y: 0.16667 },
		{ x: 0.15063, y: 0.16667 },
		{ x: 0.16736, y: 0.16667 },
		{ x: 0.1841, y: 0.16667 },
		{ x: 0.20084, y: 0.16667 },
		{ x: 0.21757, y: 0.16667 },
		{ x: 0.23431, y: 0.16667 },
		{ x: 0.25105, y: 0.16667 },
		{ x: 0, y: 0.18333 },
		{ x: 0.01674, y: 0.18333 },
		{ x: 0.03347, y: 0.18333 },
		{ x: 0.05021, y: 0.18333 },
		{ x: 0.06695, y: 0.18333 },
		{ x: 0.08368, y: 0.18333 },
		{ x: 0.10042, y: 0.18333 },
		{ x: 0.11715, y: 0.18333 },
		{ x: 0.13389, y: 0.18333 },
		{ x: 0.15063, y: 0.18333 },
		{ x: 0.16736, y: 0.18333 },
		{ x: 0.1841, y: 0.18333 },
		{ x: 0.20084, y: 0.18333 },
		{ x: 0.21757, y: 0.18333 },
		{ x: 0.23431, y: 0.18333 },
		{ x: 0.25105, y: 0.18333 },
		{ x: 0, y: 0.2 },
		{ x: 0.01674, y: 0.2 },
		{ x: 0.03347, y: 0.2 },
		{ x: 0.05021, y: 0.2 },
		{ x: 0.06695, y: 0.2 },
		{ x: 0.08368, y: 0.2 },
		{ x: 0.10042, y: 0.2 },
		{ x: 0.11715, y: 0.2 },
		{ x: 0.13389, y: 0.2 },
		{ x: 0.15063, y: 0.2 },
		{ x: 0.16736, y: 0.2 },
		{ x: 0.1841, y: 0.2 },
		{ x: 0.20084, y: 0.2 },
		{ x: 0.21757, y: 0.2 },
		{ x: 0.23431, y: 0.2 },
		{ x: 0.25105, y: 0.2 },
		{ x: 0, y: 0.21667 },
		{ x: 0.01674, y: 0.21667 },
		{ x: 0.03347, y: 0.21667 },
		{ x: 0.05021, y: 0.21667 },
		{ x: 0.06695, y: 0.21667 },
		{ x: 0.08368, y: 0.21667 },
		{ x: 0.10042, y: 0.21667 },
		{ x: 0.11715, y: 0.21667 },
		{ x: 0.13389, y: 0.21667 },
		{ x: 0.15063, y: 0.21667 },
		{ x: 0.16736, y: 0.21667 },
		{ x: 0.1841, y: 0.21667 },
		{ x: 0.20084, y: 0.21667 },
		{ x: 0.21757, y: 0.21667 },
		{ x: 0.23431, y: 0.21667 },
		{ x: 0.25105, y: 0.21667 },
		{ x: 0, y: 0.23333 },
		{ x: 0.01674, y: 0.23333 },
		{ x: 0.03347, y: 0.23333 },
		{ x: 0.05021, y: 0.23333 },
		{ x: 0.06695, y: 0.23333 },
		{ x: 0.08368, y: 0.23333 },
		{ x: 0.10042, y: 0.23333 },
		{ x: 0.11715, y: 0.23333 },
		{ x: 0.13389, y: 0.23333 },
		{ x: 0.15063, y: 0.23333 },
		{ x: 0.16736, y: 0.23333 },
		{ x: 0.1841, y: 0.23333 },
		{ x: 0.20084, y: 0.23333 },
		{ x: 0.21757, y: 0.23333 },
		{ x: 0.23431, y: 0.23333 },
		{ x: 0.25105, y: 0.23333 },
		{ x: 0, y: 0.25 },
		{ x: 0.01674, y: 0.25 },
		{ x: 0.03347, y: 0.25 },
		{ x: 0.05021, y: 0.25 },
		{ x: 0.06695, y: 0.25 },
		{ x: 0.08368, y: 0.25 },
		{ x: 0.10042, y: 0.25 },
		{ x: 0.11715, y: 0.25 },
		{ x: 0.13389, y: 0.25 },
		{ x: 0.15063, y: 0.25 },
		{ x: 0.16736, y: 0.25 },
		{ x: 0.1841, y: 0.25 },
		{ x: 0.20084, y: 0.25 },
		{ x: 0.21757, y: 0.25 },
		{ x: 0.23431, y: 0.25 },
		{ x: 0.25105, y: 0.25 },
		{ x: 0, y: 0.26667 },
		{ x: 0.01674, y: 0.26667 },
		{ x: 0.03347, y: 0.26667 },
		{ x: 0.05021, y: 0.26667 },
		{ x: 0.06695, y: 0.26667 },
		{ x: 0.08368, y: 0.26667 },
		{ x: 0.10042, y: 0.26667 },
		{ x: 0.11715, y: 0.26667 },
		{ x: 0.13389, y: 0.26667 },
		{ x: 0.15063, y: 0.26667 },
		{ x: 0.16736, y: 0.26667 },
		{ x: 0.1841, y: 0.26667 },
		{ x: 0.20084, y: 0.26667 },
		{ x: 0.21757, y: 0.26667 },
		{ x: 0.23431, y: 0.26667 },
		{ x: 0.25105, y: 0.26667 },
		{ x: 0, y: 0.28333 },
		{ x: 0.01674, y: 0.28333 },
		{ x: 0.03347, y: 0.28333 },
		{ x: 0.05021, y: 0.28333 },
		{ x: 0.06695, y: 0.28333 },
		{ x: 0.08368, y: 0.28333 },
		{ x: 0.10042, y: 0.28333 },
		{ x: 0.11715, y: 0.28333 },
		{ x: 0.13389, y: 0.28333 },
		{ x: 0.15063, y: 0.28333 },
		{ x: 0.16736, y: 0.28333 },
		{ x: 0.1841, y: 0.28333 },
		{ x: 0.20084, y: 0.28333 },
		{ x: 0.21757, y: 0.28333 },
		{ x: 0.23431, y: 0.28333 },
		{ x: 0.25105, y: 0.28333 },
		{ x: 0.68619, y: 0.28333 },
		{ x: 0.70293, y: 0.28333 },
		{ x: 0.71967, y: 0.28333 },
		{ x: 0.7364, y: 0.28333 },
		{ x: 0, y: 0.3 },
		{ x: 0.01674, y: 0.3 },
		{ x: 0.03347, y: 0.3 },
		{ x: 0.05021, y: 0.3 },
		{ x: 0.06695, y: 0.3 },
		{ x: 0.08368, y: 0.3 },
		{ x: 0.10042, y: 0.3 },
		{ x: 0.11715, y: 0.3 },
		{ x: 0.13389, y: 0.3 },
		{ x: 0.15063, y: 0.3 },
		{ x: 0.16736, y: 0.3 },
		{ x: 0.1841, y: 0.3 },
		{ x: 0.20084, y: 0.3 },
		{ x: 0.21757, y: 0.3 },
		{ x: 0.23431, y: 0.3 },
		{ x: 0.25105, y: 0.3 },
		{ x: 0.65272, y: 0.3 },
		{ x: 0.66946, y: 0.3 },
		{ x: 0.68619, y: 0.3 },
		{ x: 0.70293, y: 0.3 },
		{ x: 0.71967, y: 0.3 },
		{ x: 0.7364, y: 0.3 },
		{ x: 0.75314, y: 0.3 },
		{ x: 0.76987, y: 0.3 },
		{ x: 0.78661, y: 0.3 },
		{ x: 0, y: 0.31667 },
		{ x: 0.01674, y: 0.31667 },
		{ x: 0.03347, y: 0.31667 },
		{ x: 0.05021, y: 0.31667 },
		{ x: 0.06695, y: 0.31667 },
		{ x: 0.08368, y: 0.31667 },
		{ x: 0.10042, y: 0.31667 },
		{ x: 0.11715, y: 0.31667 },
		{ x: 0.13389, y: 0.31667 },
		{ x: 0.15063, y: 0.31667 },
		{ x: 0.16736, y: 0.31667 },
		{ x: 0.1841, y: 0.31667 },
		{ x: 0.20084, y: 0.31667 },
		{ x: 0.21757, y: 0.31667 },
		{ x: 0.23431, y: 0.31667 },
		{ x: 0.25105, y: 0.31667 },
		{ x: 0.61925, y: 0.31667 },
		{ x: 0.63598, y: 0.31667 },
		{ x: 0.65272, y: 0.31667 },
		{ x: 0.66946, y: 0.31667 },
		{ x: 0.68619, y: 0.31667 },
		{ x: 0.70293, y: 0.31667 },
		{ x: 0.71967, y: 0.31667 },
		{ x: 0.7364, y: 0.31667 },
		{ x: 0.75314, y: 0.31667 },
		{ x: 0.76987, y: 0.31667 },
		{ x: 0.78661, y: 0.31667 },
		{ x: 0.80335, y: 0.31667 },
		{ x: 0.82008, y: 0.31667 },
		{ x: 0.83682, y: 0.31667 },
		{ x: 0, y: 0.33333 },
		{ x: 0.01674, y: 0.33333 },
		{ x: 0.03347, y: 0.33333 },
		{ x: 0.05021, y: 0.33333 },
		{ x: 0.06695, y: 0.33333 },
		{ x: 0.08368, y: 0.33333 },
		{ x: 0.10042, y: 0.33333 },
		{ x: 0.11715, y: 0.33333 },
		{ x: 0.13389, y: 0.33333 },
		{ x: 0.15063, y: 0.33333 },
		{ x: 0.16736, y: 0.33333 },
		{ x: 0.1841, y: 0.33333 },
		{ x: 0.20084, y: 0.33333 },
		{ x: 0.21757, y: 0.33333 },
		{ x: 0.23431, y: 0.33333 },
		{ x: 0.25105, y: 0.33333 },
		{ x: 0.56904, y: 0.33333 },
		{ x: 0.58577, y: 0.33333 },
		{ x: 0.60251, y: 0.33333 },
		{ x: 0.61925, y: 0.33333 },
		{ x: 0.63598, y: 0.33333 },
		{ x: 0.65272, y: 0.33333 },
		{ x: 0.66946, y: 0.33333 },
		{ x: 0.68619, y: 0.33333 },
		{ x: 0.70293, y: 0.33333 },
		{ x: 0.71967, y: 0.33333 },
		{ x: 0.7364, y: 0.33333 },
		{ x: 0.75314, y: 0.33333 },
		{ x: 0.76987, y: 0.33333 },
		{ x: 0.78661, y: 0.33333 },
		{ x: 0.80335, y: 0.33333 },
		{ x: 0.82008, y: 0.33333 },
		{ x: 0.83682, y: 0.33333 },
		{ x: 0.85356, y: 0.33333 },
		{ x: 0.87029, y: 0.33333 },
		{ x: 0, y: 0.35 },
		{ x: 0.01674, y: 0.35 },
		{ x: 0.03347, y: 0.35 },
		{ x: 0.05021, y: 0.35 },
		{ x: 0.06695, y: 0.35 },
		{ x: 0.08368, y: 0.35 },
		{ x: 0.10042, y: 0.35 },
		{ x: 0.11715, y: 0.35 },
		{ x: 0.13389, y: 0.35 },
		{ x: 0.15063, y: 0.35 },
		{ x: 0.16736, y: 0.35 },
		{ x: 0.1841, y: 0.35 },
		{ x: 0.20084, y: 0.35 },
		{ x: 0.21757, y: 0.35 },
		{ x: 0.23431, y: 0.35 },
		{ x: 0.25105, y: 0.35 },
		{ x: 0.53556, y: 0.35 },
		{ x: 0.5523, y: 0.35 },
		{ x: 0.56904, y: 0.35 },
		{ x: 0.58577, y: 0.35 },
		{ x: 0.60251, y: 0.35 },
		{ x: 0.61925, y: 0.35 },
		{ x: 0.63598, y: 0.35 },
		{ x: 0.65272, y: 0.35 },
		{ x: 0.66946, y: 0.35 },
		{ x: 0.68619, y: 0.35 },
		{ x: 0.70293, y: 0.35 },
		{ x: 0.71967, y: 0.35 },
		{ x: 0.7364, y: 0.35 },
		{ x: 0.75314, y: 0.35 },
		{ x: 0.76987, y: 0.35 },
		{ x: 0.78661, y: 0.35 },
		{ x: 0.80335, y: 0.35 },
		{ x: 0.82008, y: 0.35 },
		{ x: 0.83682, y: 0.35 },
		{ x: 0.85356, y: 0.35 },
		{ x: 0.87029, y: 0.35 },
		{ x: 0.88703, y: 0.35 },
		{ x: 0.90377, y: 0.35 },
		{ x: 0.9205, y: 0.35 },
		{ x: 0, y: 0.36667 },
		{ x: 0.01674, y: 0.36667 },
		{ x: 0.03347, y: 0.36667 },
		{ x: 0.05021, y: 0.36667 },
		{ x: 0.06695, y: 0.36667 },
		{ x: 0.08368, y: 0.36667 },
		{ x: 0.10042, y: 0.36667 },
		{ x: 0.11715, y: 0.36667 },
		{ x: 0.13389, y: 0.36667 },
		{ x: 0.15063, y: 0.36667 },
		{ x: 0.16736, y: 0.36667 },
		{ x: 0.1841, y: 0.36667 },
		{ x: 0.20084, y: 0.36667 },
		{ x: 0.21757, y: 0.36667 },
		{ x: 0.23431, y: 0.36667 },
		{ x: 0.25105, y: 0.36667 },
		{ x: 0.48536, y: 0.36667 },
		{ x: 0.50209, y: 0.36667 },
		{ x: 0.51883, y: 0.36667 },
		{ x: 0.53556, y: 0.36667 },
		{ x: 0.5523, y: 0.36667 },
		{ x: 0.56904, y: 0.36667 },
		{ x: 0.58577, y: 0.36667 },
		{ x: 0.60251, y: 0.36667 },
		{ x: 0.61925, y: 0.36667 },
		{ x: 0.63598, y: 0.36667 },
		{ x: 0.65272, y: 0.36667 },
		{ x: 0.66946, y: 0.36667 },
		{ x: 0.68619, y: 0.36667 },
		{ x: 0.70293, y: 0.36667 },
		{ x: 0.71967, y: 0.36667 },
		{ x: 0.7364, y: 0.36667 },
		{ x: 0.75314, y: 0.36667 },
		{ x: 0.76987, y: 0.36667 },
		{ x: 0.78661, y: 0.36667 },
		{ x: 0.80335, y: 0.36667 },
		{ x: 0.82008, y: 0.36667 },
		{ x: 0.83682, y: 0.36667 },
		{ x: 0.85356, y: 0.36667 },
		{ x: 0.87029, y: 0.36667 },
		{ x: 0.88703, y: 0.36667 },
		{ x: 0.90377, y: 0.36667 },
		{ x: 0.9205, y: 0.36667 },
		{ x: 0.93724, y: 0.36667 },
		{ x: 0.95397, y: 0.36667 },
		{ x: 0, y: 0.38333 },
		{ x: 0.01674, y: 0.38333 },
		{ x: 0.03347, y: 0.38333 },
		{ x: 0.05021, y: 0.38333 },
		{ x: 0.06695, y: 0.38333 },
		{ x: 0.08368, y: 0.38333 },
		{ x: 0.10042, y: 0.38333 },
		{ x: 0.11715, y: 0.38333 },
		{ x: 0.13389, y: 0.38333 },
		{ x: 0.15063, y: 0.38333 },
		{ x: 0.16736, y: 0.38333 },
		{ x: 0.1841, y: 0.38333 },
		{ x: 0.20084, y: 0.38333 },
		{ x: 0.21757, y: 0.38333 },
		{ x: 0.23431, y: 0.38333 },
		{ x: 0.25105, y: 0.38333 },
		{ x: 0.50209, y: 0.38333 },
		{ x: 0.51883, y: 0.38333 },
		{ x: 0.53556, y: 0.38333 },
		{ x: 0.5523, y: 0.38333 },
		{ x: 0.56904, y: 0.38333 },
		{ x: 0.58577, y: 0.38333 },
		{ x: 0.60251, y: 0.38333 },
		{ x: 0.61925, y: 0.38333 },
		{ x: 0.63598, y: 0.38333 },
		{ x: 0.65272, y: 0.38333 },
		{ x: 0.66946, y: 0.38333 },
		{ x: 0.68619, y: 0.38333 },
		{ x: 0.70293, y: 0.38333 },
		{ x: 0.71967, y: 0.38333 },
		{ x: 0.7364, y: 0.38333 },
		{ x: 0.75314, y: 0.38333 },
		{ x: 0.76987, y: 0.38333 },
		{ x: 0.78661, y: 0.38333 },
		{ x: 0.80335, y: 0.38333 },
		{ x: 0.82008, y: 0.38333 },
		{ x: 0.83682, y: 0.38333 },
		{ x: 0.85356, y: 0.38333 },
		{ x: 0.87029, y: 0.38333 },
		{ x: 0.88703, y: 0.38333 },
		{ x: 0.90377, y: 0.38333 },
		{ x: 0.9205, y: 0.38333 },
		{ x: 0, y: 0.4 },
		{ x: 0.01674, y: 0.4 },
		{ x: 0.03347, y: 0.4 },
		{ x: 0.05021, y: 0.4 },
		{ x: 0.06695, y: 0.4 },
		{ x: 0.08368, y: 0.4 },
		{ x: 0.10042, y: 0.4 },
		{ x: 0.11715, y: 0.4 },
		{ x: 0.13389, y: 0.4 },
		{ x: 0.15063, y: 0.4 },
		{ x: 0.16736, y: 0.4 },
		{ x: 0.1841, y: 0.4 },
		{ x: 0.20084, y: 0.4 },
		{ x: 0.21757, y: 0.4 },
		{ x: 0.23431, y: 0.4 },
		{ x: 0.25105, y: 0.4 },
		{ x: 0.5523, y: 0.4 },
		{ x: 0.56904, y: 0.4 },
		{ x: 0.58577, y: 0.4 },
		{ x: 0.60251, y: 0.4 },
		{ x: 0.61925, y: 0.4 },
		{ x: 0.63598, y: 0.4 },
		{ x: 0.65272, y: 0.4 },
		{ x: 0.66946, y: 0.4 },
		{ x: 0.68619, y: 0.4 },
		{ x: 0.70293, y: 0.4 },
		{ x: 0.71967, y: 0.4 },
		{ x: 0.7364, y: 0.4 },
		{ x: 0.75314, y: 0.4 },
		{ x: 0.76987, y: 0.4 },
		{ x: 0.78661, y: 0.4 },
		{ x: 0.80335, y: 0.4 },
		{ x: 0.82008, y: 0.4 },
		{ x: 0.83682, y: 0.4 },
		{ x: 0.85356, y: 0.4 },
		{ x: 0.87029, y: 0.4 },
		{ x: 0.88703, y: 0.4 },
		{ x: 0.98745, y: 0.4 },
		{ x: 0, y: 0.41667 },
		{ x: 0.01674, y: 0.41667 },
		{ x: 0.03347, y: 0.41667 },
		{ x: 0.05021, y: 0.41667 },
		{ x: 0.06695, y: 0.41667 },
		{ x: 0.08368, y: 0.41667 },
		{ x: 0.10042, y: 0.41667 },
		{ x: 0.11715, y: 0.41667 },
		{ x: 0.13389, y: 0.41667 },
		{ x: 0.15063, y: 0.41667 },
		{ x: 0.16736, y: 0.41667 },
		{ x: 0.1841, y: 0.41667 },
		{ x: 0.20084, y: 0.41667 },
		{ x: 0.21757, y: 0.41667 },
		{ x: 0.23431, y: 0.41667 },
		{ x: 0.25105, y: 0.41667 },
		{ x: 0.58577, y: 0.41667 },
		{ x: 0.60251, y: 0.41667 },
		{ x: 0.61925, y: 0.41667 },
		{ x: 0.63598, y: 0.41667 },
		{ x: 0.65272, y: 0.41667 },
		{ x: 0.66946, y: 0.41667 },
		{ x: 0.68619, y: 0.41667 },
		{ x: 0.70293, y: 0.41667 },
		{ x: 0.71967, y: 0.41667 },
		{ x: 0.7364, y: 0.41667 },
		{ x: 0.75314, y: 0.41667 },
		{ x: 0.76987, y: 0.41667 },
		{ x: 0.78661, y: 0.41667 },
		{ x: 0.80335, y: 0.41667 },
		{ x: 0.82008, y: 0.41667 },
		{ x: 0.83682, y: 0.41667 },
		{ x: 0.95397, y: 0.41667 },
		{ x: 0.97071, y: 0.41667 },
		{ x: 0.98745, y: 0.41667 },
		{ x: 0, y: 0.43333 },
		{ x: 0.01674, y: 0.43333 },
		{ x: 0.03347, y: 0.43333 },
		{ x: 0.05021, y: 0.43333 },
		{ x: 0.06695, y: 0.43333 },
		{ x: 0.08368, y: 0.43333 },
		{ x: 0.10042, y: 0.43333 },
		{ x: 0.11715, y: 0.43333 },
		{ x: 0.13389, y: 0.43333 },
		{ x: 0.15063, y: 0.43333 },
		{ x: 0.16736, y: 0.43333 },
		{ x: 0.1841, y: 0.43333 },
		{ x: 0.20084, y: 0.43333 },
		{ x: 0.21757, y: 0.43333 },
		{ x: 0.23431, y: 0.43333 },
		{ x: 0.25105, y: 0.43333 },
		{ x: 0.61925, y: 0.43333 },
		{ x: 0.63598, y: 0.43333 },
		{ x: 0.65272, y: 0.43333 },
		{ x: 0.66946, y: 0.43333 },
		{ x: 0.68619, y: 0.43333 },
		{ x: 0.70293, y: 0.43333 },
		{ x: 0.71967, y: 0.43333 },
		{ x: 0.7364, y: 0.43333 },
		{ x: 0.75314, y: 0.43333 },
		{ x: 0.76987, y: 0.43333 },
		{ x: 0.78661, y: 0.43333 },
		{ x: 0.80335, y: 0.43333 },
		{ x: 0.9205, y: 0.43333 },
		{ x: 0.93724, y: 0.43333 },
		{ x: 0.95397, y: 0.43333 },
		{ x: 0.97071, y: 0.43333 },
		{ x: 0.98745, y: 0.43333 },
		{ x: 0, y: 0.45 },
		{ x: 0.01674, y: 0.45 },
		{ x: 0.03347, y: 0.45 },
		{ x: 0.05021, y: 0.45 },
		{ x: 0.06695, y: 0.45 },
		{ x: 0.08368, y: 0.45 },
		{ x: 0.10042, y: 0.45 },
		{ x: 0.11715, y: 0.45 },
		{ x: 0.13389, y: 0.45 },
		{ x: 0.15063, y: 0.45 },
		{ x: 0.16736, y: 0.45 },
		{ x: 0.1841, y: 0.45 },
		{ x: 0.20084, y: 0.45 },
		{ x: 0.21757, y: 0.45 },
		{ x: 0.23431, y: 0.45 },
		{ x: 0.25105, y: 0.45 },
		{ x: 0.66946, y: 0.45 },
		{ x: 0.68619, y: 0.45 },
		{ x: 0.70293, y: 0.45 },
		{ x: 0.71967, y: 0.45 },
		{ x: 0.7364, y: 0.45 },
		{ x: 0.75314, y: 0.45 },
		{ x: 0.87029, y: 0.45 },
		{ x: 0.88703, y: 0.45 },
		{ x: 0.90377, y: 0.45 },
		{ x: 0.9205, y: 0.45 },
		{ x: 0.93724, y: 0.45 },
		{ x: 0.95397, y: 0.45 },
		{ x: 0.97071, y: 0.45 },
		{ x: 0.98745, y: 0.45 },
		{ x: 0, y: 0.46667 },
		{ x: 0.01674, y: 0.46667 },
		{ x: 0.03347, y: 0.46667 },
		{ x: 0.05021, y: 0.46667 },
		{ x: 0.06695, y: 0.46667 },
		{ x: 0.08368, y: 0.46667 },
		{ x: 0.10042, y: 0.46667 },
		{ x: 0.11715, y: 0.46667 },
		{ x: 0.13389, y: 0.46667 },
		{ x: 0.15063, y: 0.46667 },
		{ x: 0.16736, y: 0.46667 },
		{ x: 0.1841, y: 0.46667 },
		{ x: 0.20084, y: 0.46667 },
		{ x: 0.21757, y: 0.46667 },
		{ x: 0.23431, y: 0.46667 },
		{ x: 0.25105, y: 0.46667 },
		{ x: 0.70293, y: 0.46667 },
		{ x: 0.71967, y: 0.46667 },
		{ x: 0.83682, y: 0.46667 },
		{ x: 0.85356, y: 0.46667 },
		{ x: 0.87029, y: 0.46667 },
		{ x: 0.88703, y: 0.46667 },
		{ x: 0.90377, y: 0.46667 },
		{ x: 0.9205, y: 0.46667 },
		{ x: 0.93724, y: 0.46667 },
		{ x: 0.95397, y: 0.46667 },
		{ x: 0.97071, y: 0.46667 },
		{ x: 0.98745, y: 0.46667 },
		{ x: 0, y: 0.48333 },
		{ x: 0.01674, y: 0.48333 },
		{ x: 0.03347, y: 0.48333 },
		{ x: 0.05021, y: 0.48333 },
		{ x: 0.06695, y: 0.48333 },
		{ x: 0.08368, y: 0.48333 },
		{ x: 0.10042, y: 0.48333 },
		{ x: 0.11715, y: 0.48333 },
		{ x: 0.13389, y: 0.48333 },
		{ x: 0.15063, y: 0.48333 },
		{ x: 0.16736, y: 0.48333 },
		{ x: 0.1841, y: 0.48333 },
		{ x: 0.20084, y: 0.48333 },
		{ x: 0.21757, y: 0.48333 },
		{ x: 0.23431, y: 0.48333 },
		{ x: 0.25105, y: 0.48333 },
		{ x: 0.78661, y: 0.48333 },
		{ x: 0.80335, y: 0.48333 },
		{ x: 0.82008, y: 0.48333 },
		{ x: 0.83682, y: 0.48333 },
		{ x: 0.85356, y: 0.48333 },
		{ x: 0.87029, y: 0.48333 },
		{ x: 0.88703, y: 0.48333 },
		{ x: 0.90377, y: 0.48333 },
		{ x: 0.9205, y: 0.48333 },
		{ x: 0.93724, y: 0.48333 },
		{ x: 0.95397, y: 0.48333 },
		{ x: 0.97071, y: 0.48333 },
		{ x: 0.98745, y: 0.48333 },
		{ x: 0, y: 0.5 },
		{ x: 0.01674, y: 0.5 },
		{ x: 0.03347, y: 0.5 },
		{ x: 0.05021, y: 0.5 },
		{ x: 0.06695, y: 0.5 },
		{ x: 0.08368, y: 0.5 },
		{ x: 0.10042, y: 0.5 },
		{ x: 0.11715, y: 0.5 },
		{ x: 0.13389, y: 0.5 },
		{ x: 0.15063, y: 0.5 },
		{ x: 0.16736, y: 0.5 },
		{ x: 0.1841, y: 0.5 },
		{ x: 0.20084, y: 0.5 },
		{ x: 0.21757, y: 0.5 },
		{ x: 0.23431, y: 0.5 },
		{ x: 0.25105, y: 0.5 },
		{ x: 0.75314, y: 0.5 },
		{ x: 0.76987, y: 0.5 },
		{ x: 0.78661, y: 0.5 },
		{ x: 0.80335, y: 0.5 },
		{ x: 0.82008, y: 0.5 },
		{ x: 0.83682, y: 0.5 },
		{ x: 0.85356, y: 0.5 },
		{ x: 0.87029, y: 0.5 },
		{ x: 0.88703, y: 0.5 },
		{ x: 0.90377, y: 0.5 },
		{ x: 0.9205, y: 0.5 },
		{ x: 0.93724, y: 0.5 },
		{ x: 0.95397, y: 0.5 },
		{ x: 0.97071, y: 0.5 },
		{ x: 0.98745, y: 0.5 },
		{ x: 0, y: 0.51667 },
		{ x: 0.01674, y: 0.51667 },
		{ x: 0.03347, y: 0.51667 },
		{ x: 0.05021, y: 0.51667 },
		{ x: 0.06695, y: 0.51667 },
		{ x: 0.08368, y: 0.51667 },
		{ x: 0.10042, y: 0.51667 },
		{ x: 0.11715, y: 0.51667 },
		{ x: 0.13389, y: 0.51667 },
		{ x: 0.15063, y: 0.51667 },
		{ x: 0.16736, y: 0.51667 },
		{ x: 0.1841, y: 0.51667 },
		{ x: 0.20084, y: 0.51667 },
		{ x: 0.21757, y: 0.51667 },
		{ x: 0.23431, y: 0.51667 },
		{ x: 0.25105, y: 0.51667 },
		{ x: 0.71967, y: 0.51667 },
		{ x: 0.7364, y: 0.51667 },
		{ x: 0.75314, y: 0.51667 },
		{ x: 0.76987, y: 0.51667 },
		{ x: 0.78661, y: 0.51667 },
		{ x: 0.80335, y: 0.51667 },
		{ x: 0.82008, y: 0.51667 },
		{ x: 0.83682, y: 0.51667 },
		{ x: 0.85356, y: 0.51667 },
		{ x: 0.87029, y: 0.51667 },
		{ x: 0.88703, y: 0.51667 },
		{ x: 0.90377, y: 0.51667 },
		{ x: 0.9205, y: 0.51667 },
		{ x: 0.93724, y: 0.51667 },
		{ x: 0.95397, y: 0.51667 },
		{ x: 0.97071, y: 0.51667 },
		{ x: 0.98745, y: 0.51667 },
		{ x: 0, y: 0.53333 },
		{ x: 0.01674, y: 0.53333 },
		{ x: 0.03347, y: 0.53333 },
		{ x: 0.05021, y: 0.53333 },
		{ x: 0.06695, y: 0.53333 },
		{ x: 0.08368, y: 0.53333 },
		{ x: 0.10042, y: 0.53333 },
		{ x: 0.11715, y: 0.53333 },
		{ x: 0.13389, y: 0.53333 },
		{ x: 0.15063, y: 0.53333 },
		{ x: 0.16736, y: 0.53333 },
		{ x: 0.1841, y: 0.53333 },
		{ x: 0.20084, y: 0.53333 },
		{ x: 0.21757, y: 0.53333 },
		{ x: 0.23431, y: 0.53333 },
		{ x: 0.25105, y: 0.53333 },
		{ x: 0.66946, y: 0.53333 },
		{ x: 0.68619, y: 0.53333 },
		{ x: 0.70293, y: 0.53333 },
		{ x: 0.71967, y: 0.53333 },
		{ x: 0.7364, y: 0.53333 },
		{ x: 0.75314, y: 0.53333 },
		{ x: 0.76987, y: 0.53333 },
		{ x: 0.78661, y: 0.53333 },
		{ x: 0.80335, y: 0.53333 },
		{ x: 0.82008, y: 0.53333 },
		{ x: 0.83682, y: 0.53333 },
		{ x: 0.85356, y: 0.53333 },
		{ x: 0.87029, y: 0.53333 },
		{ x: 0.88703, y: 0.53333 },
		{ x: 0.90377, y: 0.53333 },
		{ x: 0.9205, y: 0.53333 },
		{ x: 0.93724, y: 0.53333 },
		{ x: 0.95397, y: 0.53333 },
		{ x: 0.97071, y: 0.53333 },
		{ x: 0.98745, y: 0.53333 },
		{ x: 0, y: 0.55 },
		{ x: 0.01674, y: 0.55 },
		{ x: 0.03347, y: 0.55 },
		{ x: 0.05021, y: 0.55 },
		{ x: 0.06695, y: 0.55 },
		{ x: 0.08368, y: 0.55 },
		{ x: 0.10042, y: 0.55 },
		{ x: 0.11715, y: 0.55 },
		{ x: 0.13389, y: 0.55 },
		{ x: 0.15063, y: 0.55 },
		{ x: 0.16736, y: 0.55 },
		{ x: 0.1841, y: 0.55 },
		{ x: 0.20084, y: 0.55 },
		{ x: 0.21757, y: 0.55 },
		{ x: 0.23431, y: 0.55 },
		{ x: 0.25105, y: 0.55 },
		{ x: 0.63598, y: 0.55 },
		{ x: 0.65272, y: 0.55 },
		{ x: 0.66946, y: 0.55 },
		{ x: 0.68619, y: 0.55 },
		{ x: 0.70293, y: 0.55 },
		{ x: 0.71967, y: 0.55 },
		{ x: 0.7364, y: 0.55 },
		{ x: 0.75314, y: 0.55 },
		{ x: 0.76987, y: 0.55 },
		{ x: 0.78661, y: 0.55 },
		{ x: 0.80335, y: 0.55 },
		{ x: 0.82008, y: 0.55 },
		{ x: 0.83682, y: 0.55 },
		{ x: 0.85356, y: 0.55 },
		{ x: 0.87029, y: 0.55 },
		{ x: 0.88703, y: 0.55 },
		{ x: 0.90377, y: 0.55 },
		{ x: 0.9205, y: 0.55 },
		{ x: 0.93724, y: 0.55 },
		{ x: 0.95397, y: 0.55 },
		{ x: 0.97071, y: 0.55 },
		{ x: 0.98745, y: 0.55 },
		{ x: 0, y: 0.56667 },
		{ x: 0.01674, y: 0.56667 },
		{ x: 0.03347, y: 0.56667 },
		{ x: 0.05021, y: 0.56667 },
		{ x: 0.06695, y: 0.56667 },
		{ x: 0.08368, y: 0.56667 },
		{ x: 0.10042, y: 0.56667 },
		{ x: 0.11715, y: 0.56667 },
		{ x: 0.13389, y: 0.56667 },
		{ x: 0.15063, y: 0.56667 },
		{ x: 0.16736, y: 0.56667 },
		{ x: 0.1841, y: 0.56667 },
		{ x: 0.20084, y: 0.56667 },
		{ x: 0.21757, y: 0.56667 },
		{ x: 0.23431, y: 0.56667 },
		{ x: 0.25105, y: 0.56667 },
		{ x: 0.58577, y: 0.56667 },
		{ x: 0.60251, y: 0.56667 },
		{ x: 0.61925, y: 0.56667 },
		{ x: 0.63598, y: 0.56667 },
		{ x: 0.65272, y: 0.56667 },
		{ x: 0.66946, y: 0.56667 },
		{ x: 0.68619, y: 0.56667 },
		{ x: 0.70293, y: 0.56667 },
		{ x: 0.71967, y: 0.56667 },
		{ x: 0.7364, y: 0.56667 },
		{ x: 0.75314, y: 0.56667 },
		{ x: 0.76987, y: 0.56667 },
		{ x: 0.78661, y: 0.56667 },
		{ x: 0.80335, y: 0.56667 },
		{ x: 0.82008, y: 0.56667 },
		{ x: 0.83682, y: 0.56667 },
		{ x: 0.85356, y: 0.56667 },
		{ x: 0.87029, y: 0.56667 },
		{ x: 0.88703, y: 0.56667 },
		{ x: 0.90377, y: 0.56667 },
		{ x: 0.9205, y: 0.56667 },
		{ x: 0.93724, y: 0.56667 },
		{ x: 0.95397, y: 0.56667 },
		{ x: 0.97071, y: 0.56667 },
		{ x: 0.98745, y: 0.56667 },
		{ x: 0, y: 0.58333 },
		{ x: 0.01674, y: 0.58333 },
		{ x: 0.03347, y: 0.58333 },
		{ x: 0.05021, y: 0.58333 },
		{ x: 0.06695, y: 0.58333 },
		{ x: 0.08368, y: 0.58333 },
		{ x: 0.10042, y: 0.58333 },
		{ x: 0.11715, y: 0.58333 },
		{ x: 0.13389, y: 0.58333 },
		{ x: 0.15063, y: 0.58333 },
		{ x: 0.16736, y: 0.58333 },
		{ x: 0.1841, y: 0.58333 },
		{ x: 0.20084, y: 0.58333 },
		{ x: 0.21757, y: 0.58333 },
		{ x: 0.23431, y: 0.58333 },
		{ x: 0.25105, y: 0.58333 },
		{ x: 0.5523, y: 0.58333 },
		{ x: 0.56904, y: 0.58333 },
		{ x: 0.58577, y: 0.58333 },
		{ x: 0.60251, y: 0.58333 },
		{ x: 0.61925, y: 0.58333 },
		{ x: 0.63598, y: 0.58333 },
		{ x: 0.65272, y: 0.58333 },
		{ x: 0.66946, y: 0.58333 },
		{ x: 0.68619, y: 0.58333 },
		{ x: 0.70293, y: 0.58333 },
		{ x: 0.71967, y: 0.58333 },
		{ x: 0.7364, y: 0.58333 },
		{ x: 0.75314, y: 0.58333 },
		{ x: 0.76987, y: 0.58333 },
		{ x: 0.78661, y: 0.58333 },
		{ x: 0.80335, y: 0.58333 },
		{ x: 0.82008, y: 0.58333 },
		{ x: 0.83682, y: 0.58333 },
		{ x: 0.85356, y: 0.58333 },
		{ x: 0.87029, y: 0.58333 },
		{ x: 0.88703, y: 0.58333 },
		{ x: 0.90377, y: 0.58333 },
		{ x: 0.9205, y: 0.58333 },
		{ x: 0.93724, y: 0.58333 },
		{ x: 0.95397, y: 0.58333 },
		{ x: 0.97071, y: 0.58333 },
		{ x: 0.98745, y: 0.58333 },
		{ x: 0, y: 0.6 },
		{ x: 0.01674, y: 0.6 },
		{ x: 0.03347, y: 0.6 },
		{ x: 0.05021, y: 0.6 },
		{ x: 0.06695, y: 0.6 },
		{ x: 0.08368, y: 0.6 },
		{ x: 0.10042, y: 0.6 },
		{ x: 0.11715, y: 0.6 },
		{ x: 0.13389, y: 0.6 },
		{ x: 0.15063, y: 0.6 },
		{ x: 0.16736, y: 0.6 },
		{ x: 0.1841, y: 0.6 },
		{ x: 0.20084, y: 0.6 },
		{ x: 0.21757, y: 0.6 },
		{ x: 0.23431, y: 0.6 },
		{ x: 0.25105, y: 0.6 },
		{ x: 0.51883, y: 0.6 },
		{ x: 0.53556, y: 0.6 },
		{ x: 0.5523, y: 0.6 },
		{ x: 0.56904, y: 0.6 },
		{ x: 0.58577, y: 0.6 },
		{ x: 0.60251, y: 0.6 },
		{ x: 0.61925, y: 0.6 },
		{ x: 0.63598, y: 0.6 },
		{ x: 0.65272, y: 0.6 },
		{ x: 0.66946, y: 0.6 },
		{ x: 0.68619, y: 0.6 },
		{ x: 0.70293, y: 0.6 },
		{ x: 0.71967, y: 0.6 },
		{ x: 0.7364, y: 0.6 },
		{ x: 0.75314, y: 0.6 },
		{ x: 0.76987, y: 0.6 },
		{ x: 0.78661, y: 0.6 },
		{ x: 0.80335, y: 0.6 },
		{ x: 0.82008, y: 0.6 },
		{ x: 0.83682, y: 0.6 },
		{ x: 0.85356, y: 0.6 },
		{ x: 0.87029, y: 0.6 },
		{ x: 0.88703, y: 0.6 },
		{ x: 0.90377, y: 0.6 },
		{ x: 0.9205, y: 0.6 },
		{ x: 0.93724, y: 0.6 },
		{ x: 0.95397, y: 0.6 },
		{ x: 0.97071, y: 0.6 },
		{ x: 0, y: 0.61667 },
		{ x: 0.01674, y: 0.61667 },
		{ x: 0.03347, y: 0.61667 },
		{ x: 0.05021, y: 0.61667 },
		{ x: 0.06695, y: 0.61667 },
		{ x: 0.08368, y: 0.61667 },
		{ x: 0.10042, y: 0.61667 },
		{ x: 0.11715, y: 0.61667 },
		{ x: 0.13389, y: 0.61667 },
		{ x: 0.15063, y: 0.61667 },
		{ x: 0.16736, y: 0.61667 },
		{ x: 0.1841, y: 0.61667 },
		{ x: 0.20084, y: 0.61667 },
		{ x: 0.21757, y: 0.61667 },
		{ x: 0.23431, y: 0.61667 },
		{ x: 0.25105, y: 0.61667 },
		{ x: 0.46862, y: 0.61667 },
		{ x: 0.48536, y: 0.61667 },
		{ x: 0.50209, y: 0.61667 },
		{ x: 0.51883, y: 0.61667 },
		{ x: 0.53556, y: 0.61667 },
		{ x: 0.5523, y: 0.61667 },
		{ x: 0.56904, y: 0.61667 },
		{ x: 0.58577, y: 0.61667 },
		{ x: 0.60251, y: 0.61667 },
		{ x: 0.61925, y: 0.61667 },
		{ x: 0.63598, y: 0.61667 },
		{ x: 0.65272, y: 0.61667 },
		{ x: 0.66946, y: 0.61667 },
		{ x: 0.68619, y: 0.61667 },
		{ x: 0.70293, y: 0.61667 },
		{ x: 0.71967, y: 0.61667 },
		{ x: 0.7364, y: 0.61667 },
		{ x: 0.75314, y: 0.61667 },
		{ x: 0.76987, y: 0.61667 },
		{ x: 0.78661, y: 0.61667 },
		{ x: 0.80335, y: 0.61667 },
		{ x: 0.82008, y: 0.61667 },
		{ x: 0.83682, y: 0.61667 },
		{ x: 0.85356, y: 0.61667 },
		{ x: 0.87029, y: 0.61667 },
		{ x: 0.88703, y: 0.61667 },
		{ x: 0.90377, y: 0.61667 },
		{ x: 0.9205, y: 0.61667 },
		{ x: 0.93724, y: 0.61667 },
		{ x: 0, y: 0.63333 },
		{ x: 0.01674, y: 0.63333 },
		{ x: 0.03347, y: 0.63333 },
		{ x: 0.05021, y: 0.63333 },
		{ x: 0.06695, y: 0.63333 },
		{ x: 0.08368, y: 0.63333 },
		{ x: 0.10042, y: 0.63333 },
		{ x: 0.11715, y: 0.63333 },
		{ x: 0.13389, y: 0.63333 },
		{ x: 0.15063, y: 0.63333 },
		{ x: 0.16736, y: 0.63333 },
		{ x: 0.1841, y: 0.63333 },
		{ x: 0.20084, y: 0.63333 },
		{ x: 0.21757, y: 0.63333 },
		{ x: 0.23431, y: 0.63333 },
		{ x: 0.25105, y: 0.63333 },
		{ x: 0.43515, y: 0.63333 },
		{ x: 0.45188, y: 0.63333 },
		{ x: 0.46862, y: 0.63333 },
		{ x: 0.48536, y: 0.63333 },
		{ x: 0.50209, y: 0.63333 },
		{ x: 0.51883, y: 0.63333 },
		{ x: 0.53556, y: 0.63333 },
		{ x: 0.5523, y: 0.63333 },
		{ x: 0.56904, y: 0.63333 },
		{ x: 0.58577, y: 0.63333 },
		{ x: 0.60251, y: 0.63333 },
		{ x: 0.61925, y: 0.63333 },
		{ x: 0.63598, y: 0.63333 },
		{ x: 0.65272, y: 0.63333 },
		{ x: 0.66946, y: 0.63333 },
		{ x: 0.68619, y: 0.63333 },
		{ x: 0.70293, y: 0.63333 },
		{ x: 0.71967, y: 0.63333 },
		{ x: 0.7364, y: 0.63333 },
		{ x: 0.75314, y: 0.63333 },
		{ x: 0.76987, y: 0.63333 },
		{ x: 0.78661, y: 0.63333 },
		{ x: 0.80335, y: 0.63333 },
		{ x: 0.82008, y: 0.63333 },
		{ x: 0.83682, y: 0.63333 },
		{ x: 0.85356, y: 0.63333 },
		{ x: 0.87029, y: 0.63333 },
		{ x: 0.88703, y: 0.63333 },
		{ x: 0, y: 0.65 },
		{ x: 0.01674, y: 0.65 },
		{ x: 0.03347, y: 0.65 },
		{ x: 0.05021, y: 0.65 },
		{ x: 0.06695, y: 0.65 },
		{ x: 0.08368, y: 0.65 },
		{ x: 0.10042, y: 0.65 },
		{ x: 0.11715, y: 0.65 },
		{ x: 0.13389, y: 0.65 },
		{ x: 0.15063, y: 0.65 },
		{ x: 0.16736, y: 0.65 },
		{ x: 0.1841, y: 0.65 },
		{ x: 0.20084, y: 0.65 },
		{ x: 0.21757, y: 0.65 },
		{ x: 0.23431, y: 0.65 },
		{ x: 0.25105, y: 0.65 },
		{ x: 0.38494, y: 0.65 },
		{ x: 0.40167, y: 0.65 },
		{ x: 0.41841, y: 0.65 },
		{ x: 0.43515, y: 0.65 },
		{ x: 0.45188, y: 0.65 },
		{ x: 0.46862, y: 0.65 },
		{ x: 0.48536, y: 0.65 },
		{ x: 0.50209, y: 0.65 },
		{ x: 0.51883, y: 0.65 },
		{ x: 0.53556, y: 0.65 },
		{ x: 0.5523, y: 0.65 },
		{ x: 0.56904, y: 0.65 },
		{ x: 0.58577, y: 0.65 },
		{ x: 0.60251, y: 0.65 },
		{ x: 0.61925, y: 0.65 },
		{ x: 0.63598, y: 0.65 },
		{ x: 0.65272, y: 0.65 },
		{ x: 0.66946, y: 0.65 },
		{ x: 0.68619, y: 0.65 },
		{ x: 0.70293, y: 0.65 },
		{ x: 0.71967, y: 0.65 },
		{ x: 0.7364, y: 0.65 },
		{ x: 0.75314, y: 0.65 },
		{ x: 0.76987, y: 0.65 },
		{ x: 0.78661, y: 0.65 },
		{ x: 0.80335, y: 0.65 },
		{ x: 0.82008, y: 0.65 },
		{ x: 0.83682, y: 0.65 },
		{ x: 0.85356, y: 0.65 },
		{ x: 0, y: 0.66667 },
		{ x: 0.01674, y: 0.66667 },
		{ x: 0.03347, y: 0.66667 },
		{ x: 0.05021, y: 0.66667 },
		{ x: 0.06695, y: 0.66667 },
		{ x: 0.08368, y: 0.66667 },
		{ x: 0.10042, y: 0.66667 },
		{ x: 0.11715, y: 0.66667 },
		{ x: 0.13389, y: 0.66667 },
		{ x: 0.15063, y: 0.66667 },
		{ x: 0.16736, y: 0.66667 },
		{ x: 0.1841, y: 0.66667 },
		{ x: 0.20084, y: 0.66667 },
		{ x: 0.21757, y: 0.66667 },
		{ x: 0.23431, y: 0.66667 },
		{ x: 0.25105, y: 0.66667 },
		{ x: 0.35146, y: 0.66667 },
		{ x: 0.3682, y: 0.66667 },
		{ x: 0.38494, y: 0.66667 },
		{ x: 0.40167, y: 0.66667 },
		{ x: 0.41841, y: 0.66667 },
		{ x: 0.43515, y: 0.66667 },
		{ x: 0.45188, y: 0.66667 },
		{ x: 0.46862, y: 0.66667 },
		{ x: 0.48536, y: 0.66667 },
		{ x: 0.50209, y: 0.66667 },
		{ x: 0.51883, y: 0.66667 },
		{ x: 0.53556, y: 0.66667 },
		{ x: 0.5523, y: 0.66667 },
		{ x: 0.56904, y: 0.66667 },
		{ x: 0.58577, y: 0.66667 },
		{ x: 0.60251, y: 0.66667 },
		{ x: 0.61925, y: 0.66667 },
		{ x: 0.63598, y: 0.66667 },
		{ x: 0.65272, y: 0.66667 },
		{ x: 0.66946, y: 0.66667 },
		{ x: 0.68619, y: 0.66667 },
		{ x: 0.70293, y: 0.66667 },
		{ x: 0.71967, y: 0.66667 },
		{ x: 0.7364, y: 0.66667 },
		{ x: 0.75314, y: 0.66667 },
		{ x: 0.76987, y: 0.66667 },
		{ x: 0.78661, y: 0.66667 },
		{ x: 0.80335, y: 0.66667 },
		{ x: 0, y: 0.68333 },
		{ x: 0.01674, y: 0.68333 },
		{ x: 0.03347, y: 0.68333 },
		{ x: 0.05021, y: 0.68333 },
		{ x: 0.06695, y: 0.68333 },
		{ x: 0.08368, y: 0.68333 },
		{ x: 0.10042, y: 0.68333 },
		{ x: 0.11715, y: 0.68333 },
		{ x: 0.13389, y: 0.68333 },
		{ x: 0.15063, y: 0.68333 },
		{ x: 0.16736, y: 0.68333 },
		{ x: 0.1841, y: 0.68333 },
		{ x: 0.20084, y: 0.68333 },
		{ x: 0.21757, y: 0.68333 },
		{ x: 0.23431, y: 0.68333 },
		{ x: 0.25105, y: 0.68333 },
		{ x: 0.31799, y: 0.68333 },
		{ x: 0.33473, y: 0.68333 },
		{ x: 0.35146, y: 0.68333 },
		{ x: 0.3682, y: 0.68333 },
		{ x: 0.38494, y: 0.68333 },
		{ x: 0.40167, y: 0.68333 },
		{ x: 0.41841, y: 0.68333 },
		{ x: 0.43515, y: 0.68333 },
		{ x: 0.45188, y: 0.68333 },
		{ x: 0.46862, y: 0.68333 },
		{ x: 0.48536, y: 0.68333 },
		{ x: 0.50209, y: 0.68333 },
		{ x: 0.51883, y: 0.68333 },
		{ x: 0.53556, y: 0.68333 },
		{ x: 0.5523, y: 0.68333 },
		{ x: 0.56904, y: 0.68333 },
		{ x: 0.58577, y: 0.68333 },
		{ x: 0.60251, y: 0.68333 },
		{ x: 0.61925, y: 0.68333 },
		{ x: 0.63598, y: 0.68333 },
		{ x: 0.65272, y: 0.68333 },
		{ x: 0.66946, y: 0.68333 },
		{ x: 0.68619, y: 0.68333 },
		{ x: 0.70293, y: 0.68333 },
		{ x: 0.71967, y: 0.68333 },
		{ x: 0.7364, y: 0.68333 },
		{ x: 0.75314, y: 0.68333 },
		{ x: 0.76987, y: 0.68333 },
		{ x: 0, y: 0.7 },
		{ x: 0.01674, y: 0.7 },
		{ x: 0.03347, y: 0.7 },
		{ x: 0.05021, y: 0.7 },
		{ x: 0.06695, y: 0.7 },
		{ x: 0.08368, y: 0.7 },
		{ x: 0.10042, y: 0.7 },
		{ x: 0.11715, y: 0.7 },
		{ x: 0.13389, y: 0.7 },
		{ x: 0.15063, y: 0.7 },
		{ x: 0.16736, y: 0.7 },
		{ x: 0.1841, y: 0.7 },
		{ x: 0.20084, y: 0.7 },
		{ x: 0.21757, y: 0.7 },
		{ x: 0.23431, y: 0.7 },
		{ x: 0.25105, y: 0.7 },
		{ x: 0.26778, y: 0.7 },
		{ x: 0.28452, y: 0.7 },
		{ x: 0.30126, y: 0.7 },
		{ x: 0.31799, y: 0.7 },
		{ x: 0.33473, y: 0.7 },
		{ x: 0.35146, y: 0.7 },
		{ x: 0.3682, y: 0.7 },
		{ x: 0.38494, y: 0.7 },
		{ x: 0.40167, y: 0.7 },
		{ x: 0.41841, y: 0.7 },
		{ x: 0.43515, y: 0.7 },
		{ x: 0.45188, y: 0.7 },
		{ x: 0.46862, y: 0.7 },
		{ x: 0.48536, y: 0.7 },
		{ x: 0.50209, y: 0.7 },
		{ x: 0.51883, y: 0.7 },
		{ x: 0.53556, y: 0.7 },
		{ x: 0.5523, y: 0.7 },
		{ x: 0.56904, y: 0.7 },
		{ x: 0.58577, y: 0.7 },
		{ x: 0.60251, y: 0.7 },
		{ x: 0.61925, y: 0.7 },
		{ x: 0.63598, y: 0.7 },
		{ x: 0.65272, y: 0.7 },
		{ x: 0.66946, y: 0.7 },
		{ x: 0.68619, y: 0.7 },
		{ x: 0.70293, y: 0.7 },
		{ x: 0.71967, y: 0.7 },
		{ x: 0.7364, y: 0.7 },
		{ x: 0, y: 0.71667 },
		{ x: 0.01674, y: 0.71667 },
		{ x: 0.03347, y: 0.71667 },
		{ x: 0.05021, y: 0.71667 },
		{ x: 0.06695, y: 0.71667 },
		{ x: 0.08368, y: 0.71667 },
		{ x: 0.10042, y: 0.71667 },
		{ x: 0.11715, y: 0.71667 },
		{ x: 0.13389, y: 0.71667 },
		{ x: 0.15063, y: 0.71667 },
		{ x: 0.16736, y: 0.71667 },
		{ x: 0.1841, y: 0.71667 },
		{ x: 0.20084, y: 0.71667 },
		{ x: 0.21757, y: 0.71667 },
		{ x: 0.23431, y: 0.71667 },
		{ x: 0.25105, y: 0.71667 },
		{ x: 0.26778, y: 0.71667 },
		{ x: 0.28452, y: 0.71667 },
		{ x: 0.30126, y: 0.71667 },
		{ x: 0.31799, y: 0.71667 },
		{ x: 0.33473, y: 0.71667 },
		{ x: 0.35146, y: 0.71667 },
		{ x: 0.3682, y: 0.71667 },
		{ x: 0.38494, y: 0.71667 },
		{ x: 0.40167, y: 0.71667 },
		{ x: 0.41841, y: 0.71667 },
		{ x: 0.43515, y: 0.71667 },
		{ x: 0.45188, y: 0.71667 },
		{ x: 0.46862, y: 0.71667 },
		{ x: 0.48536, y: 0.71667 },
		{ x: 0.50209, y: 0.71667 },
		{ x: 0.51883, y: 0.71667 },
		{ x: 0.53556, y: 0.71667 },
		{ x: 0.5523, y: 0.71667 },
		{ x: 0.56904, y: 0.71667 },
		{ x: 0.58577, y: 0.71667 },
		{ x: 0.60251, y: 0.71667 },
		{ x: 0.61925, y: 0.71667 },
		{ x: 0.63598, y: 0.71667 },
		{ x: 0.65272, y: 0.71667 },
		{ x: 0.66946, y: 0.71667 },
		{ x: 0.68619, y: 0.71667 },
		{ x: 0, y: 0.73333 },
		{ x: 0.01674, y: 0.73333 },
		{ x: 0.03347, y: 0.73333 },
		{ x: 0.05021, y: 0.73333 },
		{ x: 0.06695, y: 0.73333 },
		{ x: 0.08368, y: 0.73333 },
		{ x: 0.10042, y: 0.73333 },
		{ x: 0.11715, y: 0.73333 },
		{ x: 0.13389, y: 0.73333 },
		{ x: 0.15063, y: 0.73333 },
		{ x: 0.16736, y: 0.73333 },
		{ x: 0.1841, y: 0.73333 },
		{ x: 0.20084, y: 0.73333 },
		{ x: 0.21757, y: 0.73333 },
		{ x: 0.23431, y: 0.73333 },
		{ x: 0.25105, y: 0.73333 },
		{ x: 0.26778, y: 0.73333 },
		{ x: 0.28452, y: 0.73333 },
		{ x: 0.30126, y: 0.73333 },
		{ x: 0.31799, y: 0.73333 },
		{ x: 0.33473, y: 0.73333 },
		{ x: 0.35146, y: 0.73333 },
		{ x: 0.3682, y: 0.73333 },
		{ x: 0.38494, y: 0.73333 },
		{ x: 0.40167, y: 0.73333 },
		{ x: 0.41841, y: 0.73333 },
		{ x: 0.43515, y: 0.73333 },
		{ x: 0.45188, y: 0.73333 },
		{ x: 0.46862, y: 0.73333 },
		{ x: 0.48536, y: 0.73333 },
		{ x: 0.50209, y: 0.73333 },
		{ x: 0.51883, y: 0.73333 },
		{ x: 0.53556, y: 0.73333 },
		{ x: 0.5523, y: 0.73333 },
		{ x: 0.56904, y: 0.73333 },
		{ x: 0.58577, y: 0.73333 },
		{ x: 0.60251, y: 0.73333 },
		{ x: 0.61925, y: 0.73333 },
		{ x: 0.63598, y: 0.73333 },
		{ x: 0.65272, y: 0.73333 },
		{ x: 0, y: 0.75 },
		{ x: 0.01674, y: 0.75 },
		{ x: 0.03347, y: 0.75 },
		{ x: 0.05021, y: 0.75 },
		{ x: 0.06695, y: 0.75 },
		{ x: 0.08368, y: 0.75 },
		{ x: 0.10042, y: 0.75 },
		{ x: 0.11715, y: 0.75 },
		{ x: 0.13389, y: 0.75 },
		{ x: 0.15063, y: 0.75 },
		{ x: 0.16736, y: 0.75 },
		{ x: 0.1841, y: 0.75 },
		{ x: 0.20084, y: 0.75 },
		{ x: 0.21757, y: 0.75 },
		{ x: 0.23431, y: 0.75 },
		{ x: 0.25105, y: 0.75 },
		{ x: 0.26778, y: 0.75 },
		{ x: 0.28452, y: 0.75 },
		{ x: 0.30126, y: 0.75 },
		{ x: 0.31799, y: 0.75 },
		{ x: 0.33473, y: 0.75 },
		{ x: 0.35146, y: 0.75 },
		{ x: 0.3682, y: 0.75 },
		{ x: 0.38494, y: 0.75 },
		{ x: 0.40167, y: 0.75 },
		{ x: 0.41841, y: 0.75 },
		{ x: 0.43515, y: 0.75 },
		{ x: 0.45188, y: 0.75 },
		{ x: 0.46862, y: 0.75 },
		{ x: 0.48536, y: 0.75 },
		{ x: 0.50209, y: 0.75 },
		{ x: 0.51883, y: 0.75 },
		{ x: 0.53556, y: 0.75 },
		{ x: 0.5523, y: 0.75 },
		{ x: 0.56904, y: 0.75 },
		{ x: 0.58577, y: 0.75 },
		{ x: 0.60251, y: 0.75 },
		{ x: 0, y: 0.76667 },
		{ x: 0.01674, y: 0.76667 },
		{ x: 0.03347, y: 0.76667 },
		{ x: 0.05021, y: 0.76667 },
		{ x: 0.06695, y: 0.76667 },
		{ x: 0.08368, y: 0.76667 },
		{ x: 0.10042, y: 0.76667 },
		{ x: 0.11715, y: 0.76667 },
		{ x: 0.13389, y: 0.76667 },
		{ x: 0.15063, y: 0.76667 },
		{ x: 0.16736, y: 0.76667 },
		{ x: 0.1841, y: 0.76667 },
		{ x: 0.20084, y: 0.76667 },
		{ x: 0.21757, y: 0.76667 },
		{ x: 0.23431, y: 0.76667 },
		{ x: 0.25105, y: 0.76667 },
		{ x: 0.26778, y: 0.76667 },
		{ x: 0.28452, y: 0.76667 },
		{ x: 0.30126, y: 0.76667 },
		{ x: 0.31799, y: 0.76667 },
		{ x: 0.33473, y: 0.76667 },
		{ x: 0.35146, y: 0.76667 },
		{ x: 0.3682, y: 0.76667 },
		{ x: 0.38494, y: 0.76667 },
		{ x: 0.40167, y: 0.76667 },
		{ x: 0.41841, y: 0.76667 },
		{ x: 0.43515, y: 0.76667 },
		{ x: 0.45188, y: 0.76667 },
		{ x: 0.46862, y: 0.76667 },
		{ x: 0.48536, y: 0.76667 },
		{ x: 0.50209, y: 0.76667 },
		{ x: 0.51883, y: 0.76667 },
		{ x: 0.53556, y: 0.76667 },
		{ x: 0.5523, y: 0.76667 },
		{ x: 0.56904, y: 0.76667 },
		{ x: 0, y: 0.78333 },
		{ x: 0.01674, y: 0.78333 },
		{ x: 0.03347, y: 0.78333 },
		{ x: 0.05021, y: 0.78333 },
		{ x: 0.06695, y: 0.78333 },
		{ x: 0.08368, y: 0.78333 },
		{ x: 0.10042, y: 0.78333 },
		{ x: 0.11715, y: 0.78333 },
		{ x: 0.13389, y: 0.78333 },
		{ x: 0.15063, y: 0.78333 },
		{ x: 0.16736, y: 0.78333 },
		{ x: 0.1841, y: 0.78333 },
		{ x: 0.20084, y: 0.78333 },
		{ x: 0.21757, y: 0.78333 },
		{ x: 0.23431, y: 0.78333 },
		{ x: 0.25105, y: 0.78333 },
		{ x: 0.26778, y: 0.78333 },
		{ x: 0.28452, y: 0.78333 },
		{ x: 0.30126, y: 0.78333 },
		{ x: 0.31799, y: 0.78333 },
		{ x: 0.33473, y: 0.78333 },
		{ x: 0.35146, y: 0.78333 },
		{ x: 0.3682, y: 0.78333 },
		{ x: 0.38494, y: 0.78333 },
		{ x: 0.40167, y: 0.78333 },
		{ x: 0.41841, y: 0.78333 },
		{ x: 0.43515, y: 0.78333 },
		{ x: 0.45188, y: 0.78333 },
		{ x: 0.46862, y: 0.78333 },
		{ x: 0.48536, y: 0.78333 },
		{ x: 0.50209, y: 0.78333 },
		{ x: 0.51883, y: 0.78333 },
		{ x: 0, y: 0.8 },
		{ x: 0.01674, y: 0.8 },
		{ x: 0.03347, y: 0.8 },
		{ x: 0.05021, y: 0.8 },
		{ x: 0.06695, y: 0.8 },
		{ x: 0.08368, y: 0.8 },
		{ x: 0.10042, y: 0.8 },
		{ x: 0.11715, y: 0.8 },
		{ x: 0.13389, y: 0.8 },
		{ x: 0.15063, y: 0.8 },
		{ x: 0.16736, y: 0.8 },
		{ x: 0.1841, y: 0.8 },
		{ x: 0.20084, y: 0.8 },
		{ x: 0.21757, y: 0.8 },
		{ x: 0.23431, y: 0.8 },
		{ x: 0.25105, y: 0.8 },
		{ x: 0.26778, y: 0.8 },
		{ x: 0.28452, y: 0.8 },
		{ x: 0.30126, y: 0.8 },
		{ x: 0.31799, y: 0.8 },
		{ x: 0.33473, y: 0.8 },
		{ x: 0.35146, y: 0.8 },
		{ x: 0.3682, y: 0.8 },
		{ x: 0.38494, y: 0.8 },
		{ x: 0.40167, y: 0.8 },
		{ x: 0.41841, y: 0.8 },
		{ x: 0.43515, y: 0.8 },
		{ x: 0.45188, y: 0.8 },
		{ x: 0.46862, y: 0.8 },
		{ x: 0.48536, y: 0.8 },
		{ x: 0, y: 0.81667 },
		{ x: 0.01674, y: 0.81667 },
		{ x: 0.03347, y: 0.81667 },
		{ x: 0.05021, y: 0.81667 },
		{ x: 0.06695, y: 0.81667 },
		{ x: 0.08368, y: 0.81667 },
		{ x: 0.10042, y: 0.81667 },
		{ x: 0.11715, y: 0.81667 },
		{ x: 0.13389, y: 0.81667 },
		{ x: 0.15063, y: 0.81667 },
		{ x: 0.16736, y: 0.81667 },
		{ x: 0.1841, y: 0.81667 },
		{ x: 0.20084, y: 0.81667 },
		{ x: 0.21757, y: 0.81667 },
		{ x: 0.23431, y: 0.81667 },
		{ x: 0.25105, y: 0.81667 },
		{ x: 0.26778, y: 0.81667 },
		{ x: 0.28452, y: 0.81667 },
		{ x: 0.30126, y: 0.81667 },
		{ x: 0.31799, y: 0.81667 },
		{ x: 0.33473, y: 0.81667 },
		{ x: 0.35146, y: 0.81667 },
		{ x: 0.3682, y: 0.81667 },
		{ x: 0.38494, y: 0.81667 },
		{ x: 0.40167, y: 0.81667 },
		{ x: 0.41841, y: 0.81667 },
		{ x: 0.43515, y: 0.81667 },
		{ x: 0.45188, y: 0.81667 },
		{ x: 0, y: 0.83333 },
		{ x: 0.01674, y: 0.83333 },
		{ x: 0.03347, y: 0.83333 },
		{ x: 0.05021, y: 0.83333 },
		{ x: 0.06695, y: 0.83333 },
		{ x: 0.08368, y: 0.83333 },
		{ x: 0.10042, y: 0.83333 },
		{ x: 0.11715, y: 0.83333 },
		{ x: 0.13389, y: 0.83333 },
		{ x: 0.15063, y: 0.83333 },
		{ x: 0.16736, y: 0.83333 },
		{ x: 0.1841, y: 0.83333 },
		{ x: 0.20084, y: 0.83333 },
		{ x: 0.21757, y: 0.83333 },
		{ x: 0.23431, y: 0.83333 },
		{ x: 0.25105, y: 0.83333 },
		{ x: 0.26778, y: 0.83333 },
		{ x: 0.28452, y: 0.83333 },
		{ x: 0.30126, y: 0.83333 },
		{ x: 0.31799, y: 0.83333 },
		{ x: 0.33473, y: 0.83333 },
		{ x: 0.35146, y: 0.83333 },
		{ x: 0.3682, y: 0.83333 },
		{ x: 0.38494, y: 0.83333 },
		{ x: 0.40167, y: 0.83333 },
		{ x: 0, y: 0.85 },
		{ x: 0.01674, y: 0.85 },
		{ x: 0.03347, y: 0.85 },
		{ x: 0.05021, y: 0.85 },
		{ x: 0.06695, y: 0.85 },
		{ x: 0.08368, y: 0.85 },
		{ x: 0.10042, y: 0.85 },
		{ x: 0.11715, y: 0.85 },
		{ x: 0.13389, y: 0.85 },
		{ x: 0.15063, y: 0.85 },
		{ x: 0.16736, y: 0.85 },
		{ x: 0.1841, y: 0.85 },
		{ x: 0.20084, y: 0.85 },
		{ x: 0.21757, y: 0.85 },
		{ x: 0.23431, y: 0.85 },
		{ x: 0.25105, y: 0.85 },
		{ x: 0.26778, y: 0.85 },
		{ x: 0.28452, y: 0.85 },
		{ x: 0.30126, y: 0.85 },
		{ x: 0.31799, y: 0.85 },
		{ x: 0.33473, y: 0.85 },
		{ x: 0.35146, y: 0.85 },
		{ x: 0.3682, y: 0.85 },
		{ x: 0, y: 0.86667 },
		{ x: 0.01674, y: 0.86667 },
		{ x: 0.03347, y: 0.86667 },
		{ x: 0.05021, y: 0.86667 },
		{ x: 0.06695, y: 0.86667 },
		{ x: 0.08368, y: 0.86667 },
		{ x: 0.10042, y: 0.86667 },
		{ x: 0.11715, y: 0.86667 },
		{ x: 0.13389, y: 0.86667 },
		{ x: 0.15063, y: 0.86667 },
		{ x: 0.16736, y: 0.86667 },
		{ x: 0.1841, y: 0.86667 },
		{ x: 0.20084, y: 0.86667 },
		{ x: 0.21757, y: 0.86667 },
		{ x: 0.23431, y: 0.86667 },
		{ x: 0.25105, y: 0.86667 },
		{ x: 0.26778, y: 0.86667 },
		{ x: 0.28452, y: 0.86667 },
		{ x: 0.30126, y: 0.86667 },
		{ x: 0.31799, y: 0.86667 },
		{ x: 0, y: 0.88333 },
		{ x: 0.01674, y: 0.88333 },
		{ x: 0.03347, y: 0.88333 },
		{ x: 0.05021, y: 0.88333 },
		{ x: 0.06695, y: 0.88333 },
		{ x: 0.08368, y: 0.88333 },
		{ x: 0.10042, y: 0.88333 },
		{ x: 0.11715, y: 0.88333 },
		{ x: 0.13389, y: 0.88333 },
		{ x: 0.15063, y: 0.88333 },
		{ x: 0.16736, y: 0.88333 },
		{ x: 0.1841, y: 0.88333 },
		{ x: 0.20084, y: 0.88333 },
		{ x: 0.21757, y: 0.88333 },
		{ x: 0.23431, y: 0.88333 },
		{ x: 0.25105, y: 0.88333 },
		{ x: 0.26778, y: 0.88333 },
		{ x: 0.28452, y: 0.88333 },
		{ x: 0, y: 0.9 },
		{ x: 0.01674, y: 0.9 },
		{ x: 0.03347, y: 0.9 },
		{ x: 0.05021, y: 0.9 },
		{ x: 0.06695, y: 0.9 },
		{ x: 0.08368, y: 0.9 },
		{ x: 0.10042, y: 0.9 },
		{ x: 0.11715, y: 0.9 },
		{ x: 0.13389, y: 0.9 },
		{ x: 0.15063, y: 0.9 },
		{ x: 0.16736, y: 0.9 },
		{ x: 0.1841, y: 0.9 },
		{ x: 0.20084, y: 0.9 },
		{ x: 0.21757, y: 0.9 },
		{ x: 0.23431, y: 0.9 },
		{ x: 0, y: 0.91667 },
		{ x: 0.01674, y: 0.91667 },
		{ x: 0.03347, y: 0.91667 },
		{ x: 0.05021, y: 0.91667 },
		{ x: 0.06695, y: 0.91667 },
		{ x: 0.08368, y: 0.91667 },
		{ x: 0.10042, y: 0.91667 },
		{ x: 0.11715, y: 0.91667 },
		{ x: 0.13389, y: 0.91667 },
		{ x: 0.15063, y: 0.91667 },
		{ x: 0.16736, y: 0.91667 },
		{ x: 0.1841, y: 0.91667 },
		{ x: 0.20084, y: 0.91667 },
		{ x: 0, y: 0.93333 },
		{ x: 0.01674, y: 0.93333 },
		{ x: 0.03347, y: 0.93333 },
		{ x: 0.05021, y: 0.93333 },
		{ x: 0.06695, y: 0.93333 },
		{ x: 0.08368, y: 0.93333 },
		{ x: 0.10042, y: 0.93333 },
		{ x: 0.11715, y: 0.93333 },
		{ x: 0.13389, y: 0.93333 },
		{ x: 0.15063, y: 0.93333 },
		{ x: 0, y: 0.95 },
		{ x: 0.01674, y: 0.95 },
		{ x: 0.03347, y: 0.95 },
		{ x: 0.05021, y: 0.95 },
		{ x: 0.06695, y: 0.95 },
		{ x: 0.08368, y: 0.95 },
		{ x: 0.10042, y: 0.95 },
		{ x: 0.11715, y: 0.95 },
		{ x: 0, y: 0.96667 },
		{ x: 0.01674, y: 0.96667 },
		{ x: 0.03347, y: 0.96667 },
		{ x: 0.05021, y: 0.96667 },
		{ x: 0.06695, y: 0.96667 },
		{ x: 0.08368, y: 0.96667 },
		{ x: 0, y: 0.98333 },
		{ x: 0.01674, y: 0.98333 },
		{ x: 0.03347, y: 0.98333 }
	]
};
